import { useCallback } from "react";
import { executeAlert } from "../../application/states/toast-alert/toast-alert";
import { useAppDispatch } from "../../presentation/hooks/store-hooks";

export const useToastAlertService = () => {
  const dispatch = useAppDispatch();

  const showSuccess = useCallback((message: string) => {
    dispatch(executeAlert({ message, type: 'success' }));
  }, [dispatch]);

  const showError = useCallback((message: string) => {
    dispatch(executeAlert({ message, type: 'error' }));
  }, [dispatch]);

  const showInfo = useCallback((message: string) => {
    dispatch(executeAlert({ message, type: 'info' }));
  }, [dispatch]);

  const showWarning = useCallback((message: string) => {
    dispatch(executeAlert({ message, type: 'warning' }));
  }, [dispatch]);

  return {
    showSuccess,
    showError,
    showInfo,
    showWarning
  };
};
